<style scoped="scoped" lang="scss">
.inputClass /deep/ .el-input__inner {
  height: 28px !important;

}

.inputClass /deep/ .el-input__icon {
  //width: 25px !important;;
  line-height: 20px !important;
}
</style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/supplier/asn/purchase/page" getKey="rows"
                   :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('asndanhao')">
            <el-input v-model="yt.conditions.asnNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')">
            <yi_cross_select multiple :component="'web_wms_purchase_receipt_supplier_information'"
                             :ids.sync="yt.conditions.supplierIds"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select :type="'ASN_ORDER_STATUS'" :ids.sync="yt.conditions.orderStatus">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear()">{{$t('chongzhi')}}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!--       左侧按钮插槽-->
      <template #buttonsL>
        <!--              <el-button size="mini" v-if="utils.checkPower('web_purchasing_management_purchase_order_create')"-->
        <!--                         @click="yt.showEditDialog('xinzeng',null,'80%',beforeShowEditDialog);getSupplierList();getCustomer();setDefaultValue();"-->
        <!--                         type="primary">-->
        <!--                {{$t('xinzeng')}}-->
        <!--              </el-button>-->
        <el-button type="primary" size="mini"
                   @click="yt.showEditDialog('xinjiandaohuodan', null,'80%');getSupplierList();getConfiguration()">
          {{$t('xinjiandaohuodan')}}
        </el-button>
      </template>
      <template #danjudalei="scope">
        {{
          $t(store.state.dictJsonAll["DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE"][scope.row.documentTypeConfiguration.categories])
        }}
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('chakan', scope.row,'80%', beforeEdit)"
                       v-if="scope.row.orderStatus === '2'||scope.row.orderStatus === '3'||scope.row.orderStatus === '4'">
              {{$t('chakan')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="printFile"
                       v-if="scope.row.orderStatus === '2'||scope.row.orderStatus === '3'||scope.row.orderStatus === '4'">
              {{$t('dayin')}}
            </el-button>
          </el-col>
<!--          <el-col :span="0.1">-->
<!--            <el-button v-if="scope.row.reviewStatus === '1'" type="text" class="font-color-danger"-->
<!--                       @click="yt.remove(scope.row,'/web/supplier/asn/delete')">-->
<!--              {{$t('shanchu')}}-->
<!--            </el-button>-->
<!--          </el-col>-->
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body"
               :destroy-on-close="true" >
      <!-- 新建送货单 -->
      <template v-if="yt.editObj.action == 'xinjiandaohuodan'">
        {{
          $nextTick(() => {
            $refs.yt2.list = addList
          })
        }}
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{$t('rukudantouxinxi')}}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth"
                     style="margin-left: 100px">
              <el-form-item :label="$t('danjudalei')" required>
                {{$t('caigouruku')}}
              </el-form-item>
              <el-form-item :label="$t('danjuxiaolei')" required class="noborder">
                <el-select v-model="yt.editObj.documentTypeConfigurationId" clearable filterable>
                  <el-option v-for="(item, index) in smallNameList" :key="index" :label="item.smallName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangmingcheng')" required>
                <yi_cross_select  :selectTitle="'name'" class="inputClass" :max="1"
                                 :component="'web_wms_purchase_receipt_supplier_information'"
                                 :ids.sync="yt.editObj.supplierId"
                                 @getItems="getItemAddress"
                                 ></yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangdizhi')" required>
                <el-input v-model="yt.editObj.address" @input="$forceUpdate()"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuodizhi')" required>
                <el-input v-model="yt.editObj.receiptAddress"></el-input>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{$t('rukudanmingxixinxi')}}
          </div>
          <div style="flex:1;">
            <yi_curd_table v-bind="$attrs" :name="$options.name+'2'" ref="yt2" :isRandKey="false"
                           :columns="columnsItem">
              <template #buttonsL="scope">
                <span>
                   <yi_cross_select v-if="isShowButton" :isButton="true" :key="scope._index" :selectTitle="'purchaserOrder.no'" class="inputClass" :max="999" :multiple="true"
                   :component="'web_supplier_portal_purchase_order_accept_list'"
                   :ids.sync="purchaseOrderDetailIds" :name="'web_purchasing_management_asn_list'" :fixConditions="{supplierIds:supplierId,deliveryQuantityResidueNotZero:true}"
                   @getItems="getPurchaseOrder(scope._index, $event)" :disabled="yt.editObj.supplierId==null"></yi_cross_select>
                </span>
              </template>
              <!--              <template #rukudingdanhanghao="scope">-->
              <!--                <el-input class="inputClass" v-model="scope.row.no"></el-input>-->
              <!--              </template>-->
              <template #caigoudingdanhao="scope">
                {{scope.row.purchaserOrderNo}}
                 <!-- <span>
                   <yi_cross_select :isButton="true" :key="scope._index" :selectTitle="'purchaserOrder.no'" class="inputClass" :max="999" :multiple="true"
                   :component="'web_supplier_portal_purchase_order_accept_list'"
                   :ids.sync="scope.row.purchaseOrderDetailId" :name="'web_purchasing_management_asn_list'" :fixConditions="{supplierIds:supplierId,deliveryQuantityResidueNotZero:true}"
                   @getItems="getPurchaseOrder(scope._index, $event)"></yi_cross_select>
                </span> -->
                <!-- <el-input class="inputClass" v-model="scope.row.purchaserOrderNo"></el-input> -->
              </template>
              <template #caigoudingdanhanghao="scope">
                <el-input class="inputClass" v-model="scope.row.no"></el-input>
              </template>
              <template #wuliaobianmamingcheng="scope">
                <el-input class="inputClass" v-model="scope.row.codeName" disabled></el-input>
              </template>
              <template #dingdanshuliang="scope">
                <el-input class="inputClass" v-model="scope.row.quantity" disabled></el-input>
              </template>
              <template #caigoudanwei="scope">
                <el-input class="inputClass" v-model="scope.row.unit" disabled></el-input>
              </template>
              <template #bencisonghuoshuliang="scope">
                <el-input-number class="inputClass" :precision="5" v-model="scope.row.deliveryQuantity"
                                 :controls="false"></el-input-number>
              </template>
              <template #shishoushuliang="scope">
                <!--                                <el-input class="inputClass" v-model="scope.row.tolerance"></el-input>-->
                <el-input-number class="inputClass" :precision="1" :min="0" v-model="scope.row.receiveQuantity"
                                 :controls="false"></el-input-number>
              </template>
              <template #sehao="scope">
                <yi_dictionary_select class="inputClass" type="CUSTOMER_MATERIAL_COLOR_NO" :ids.sync="scope.row.colorNo"></yi_dictionary_select>
              </template>
              <template #shengchanriqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date"
                               :time.sync="scope.row.productionDate">
                </yi_time_input>
              </template>
              <template #shixiaoriqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date"
                               :time.sync="scope.row.expirationDate">
                </yi_time_input>
              </template>
              <template #shouhuoriqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date"
                               :time.sync="scope.row.receiptDate">
                </yi_time_input>
              </template>
              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger"
                               @click="removeAdd(scope._index, $event)">
                      {{$t('shanchu')}}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>

          </div>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          	<el-button size="mini" :loading="yt.editObj.loading"
                       @click="yt.req('POST','/web/supplier/asn/new/delivery/order', beforeAdd)"
                       type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <!--查看-->
      <template v-if="yt.editObj.action == 'chakan'">
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{$t('caigoudingdantouxinxi')}}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth"
                     style="margin-left: 100px">
              <el-form-item :label="$t('danjudalei')" required>
                <!--                $t(store.state.dictJsonAll["DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE"][scope.row.documentTypeConfiguration.categories])-->
                <span
                    style="margin-left: 15px">{{$t(store.state.dictJsonAll['DOCUMENT_TYPE_CONFIGURATION_WAREHOUSING_TYPE'][yt.editObj.documentTypeConfiguration.categories])}}</span>
              </el-form-item>
              <el-form-item :label="$t('danjuxiaolei')" required class="noborder">
                <el-input v-model="yt.editObj.documentTypeConfiguration.smallName" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangmingcheng')" required class="noborder">
                <el-select collapse-tags v-model="yt.editObj.supplierId" filterable disabled>
                  <el-option v-for="(item, index) in supplierList" :key="index" :label="item.supplierCodeName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('gongyingshangdizhi')" required class="noborder">
                <el-input v-model="yt.editObj.supplier.address" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('shouhuodizhi')" required class="noborder">
                <el-input v-model="yt.editObj.receiptAddress" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('beizhu')" class="noborder">
                <el-input v-model="yt.editObj.remark" disabled></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{$t('caigoudingdanmingxixinxi')}}
          </div>
          <div style="flex:1;">
            <check_detail v-if="yt.isShowEditDialog" :id="yt.editObj.id" :asn="yt.editObj.asnNo" :colorNoEnable="colorNoEnable"></check_detail>
          </div>
        </div>
      </template>
    
      
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import check_detail from '@@/pages/web/purchasing_management/asn/check_detail'
export default {
  name: 'web_purchasing_management_asn_list',
  components: {
    check_detail
  },
  data() {
    return {
      isShowButton: true,
      purchaseOrderDetailIds: [],
      addList: [],
      editList: [],
      supplierList: [],
      smallNameList:[],
      supplierId:null,
      isShowEditDialog:false,
      colorNoEnable: false,
      columns: [{
        label: 'asndanhao',
        prop: 'asnNo',
        width: 130
      }, {
        label: 'danjudalei',
        prop: 'documentTypeConfiguration.categories',
        type: 'slot',
        width: 130
      },
        {
          label: 'danjuxiaolei',
          prop: 'documentTypeConfiguration.smallName',
          width: 130
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name',
          width: 130
        },
        {
          label: 'gongyingshangdizhi',
          prop: 'supplier.address',
          width: 130
        },
        {
          label: 'shouhuodizhi',
          prop: 'receiptAddress',
          width: 130,
        },
        {
          label: 'fahuoriqi',
          prop: 'shipDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 150
        },
        {
          label: 'yujidaohuoshijian',
          prop: 'expectArrivalDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 130
        },
        {
          label: 'shouhuoriqi',
          prop: 'receiptDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 130
        }, {
          label: 'songhuochepaihao',
          prop: 'deliveryLicensePlateNo',
          width: 130
        }, {
          label: 'sijidianhua',
          prop: 'driverPhone',
          width: 130
        }, {
          label: 'wuliugongsi',
          prop: 'logisticsCompany',
          width: 130
        }, {
          label: 'wuliudanhao',
          prop: 'logisticsNo',
          width: 130
        },
        {
          label: 'shenhezhuangtai',
          prop: 'reviewStatus',
          type: "dictionary_tag",
          key: "ASN_REVIEW_STATUS",
        }, {
          label: 'danjuzhuangtai',
          prop: 'orderStatus',
          type: "dictionary_tag",
          key: "ASN_ORDER_STATUS",
        }, {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130
        }, {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          // format: 'YYYY-MM-DD HH:mm:ss',
          width: 180
        }, {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }],
      //编辑
      columnsItem: [{
        label: 'caigoudingdanhao',
        prop: 'purchaserOrde.no',
        type: 'slot',
        wrap: true,
        isStar: true,
        width: 130
      }, {
        label: 'caigoudingdanhanghao',
        prop: 'status',
        type: 'slot',
        wrap: true,
        width: 130
      }, {
        label: 'wuliaobianmamingcheng',
        prop: 'materialId',
        type: 'slot',
        wrap: true,
        isStar: true,
        width: 130
      }, {
        label: 'dingdanshuliang',
        prop: 'quantity',
        type: 'slot',
        wrap: true,
        isStar: true,
        width: 130
      },
      {
        label: 'leijisonghuoshuliang',
        prop: 'deliveryQuantitySum',
        width: 130
      },
      {
        label: 'daisonghuoshuliang',
        prop: 'deliveryQuantityResidue',
        width: 130
      },
       {
        label: 'caigoudanwei',
        prop: 'defaultUnit',
        type: 'slot',
        wrap: true,
        isStar: true,
        // width: 130
      }, {
        label: 'bencisonghuoshuliang',
        prop: 'deliveryTime',
        width: 180,
        type: 'slot',
        wrap: true,
        isStar: true,
        // width: 130
      }, {
        label: 'shishoushuliang',
        prop: 'tolerance',
        type: 'slot',
        wrap: true,
        width: 160
      }, {
        label: 'sehao',
        prop: 'colorNo',
        type: 'slot',
        wrap: true,
        width: 160,
        show: false
      }, {
        label: 'shengchanriqi',
        prop: 'productionDate',
        type: 'slot',
        wrap: true,
        width: 160
      }, {
        label: 'shixiaoriqi',
        prop: 'expirationDate',
        type: 'slot',
        wrap: true,
        width: 160
      }, {
        label: 'shouhuoriqi',
        prop: 'receiptDate',
        type: 'slot',
        wrap: true,
        width: 160
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 100,
        wrap: true,
        fixed: 'right'
      }],
      //  查看列
      checkItem: [{
        label: 'mingxizhuangtai',
        prop: 'detailStatus',
        width: 160,
        type: 'dictionary_tag',
        key: "ASN_DETAIL_STATUS",
      },{
        label: 'caigoudingdanhao',
        prop: 'purchaseOrder.no',
        width: 130
      }, {
        label: 'caigoudingdanhanghao',
        prop: 'purchaseOrderDetail.no',
        width: 130
      }, {
        label: 'wuliaobianmamingcheng',
        prop: 'purchaseOrderDetail.material.name',
        width: 130
      }, {
        label: 'wuliaopicihao',
        prop: 'materialBatchNo',
        width: 130
      }, {
        label: 'dingdanshuliang',
        prop: 'purchaseOrderDetail.quantity',
        width: 130
      }, 
      		  {
        label: 'leijisonghuoshuliang',
        prop: 'deliveryQuantitySum',
        width: 130
      },
      {
        label: 'daisonghuoshuliang',
        prop: 'deliveryQuantityResidue',
        width: 130
      },{
        label: 'caigoudanwei',
        prop: 'purchaseOrderDetail.unit',
      }, {
        label: 'bencisonghuoshuliang',
        prop: 'deliveryQuantity',
        // type: 'slot',
        // wrap: true,
        width: 180,
      }, {
        label: 'yishoushuliang',
        prop: 'receiveQuantity',
        width: 160
      }, {
        label: 'weishoushuliang',
        prop: 'unreceiveQuantity',
        width: 160
      }, {
        label: 'shouhuokuwei',
        prop: 'receiveLocationName',
        width: 160
      }, {
        label: 'yishangjiashuliang',
        prop: 'listedQuantity',
        width: 160
      }, {
        label: 'weishangjiashuliang',
        prop: 'unlistedQuantity',
        width: 160
      }, {
        label: 'shangjiakuwei',
        prop: 'listedLocationName',
        width: 160
      }, {
        label: 'jianyanjieguo',
        prop: 'iqc.inspectionResult',
        type: "dictionary_tag",
        key: "TEST_RESULTS",
        wrap: true,
      }, {
        label: 'pandingjieguo',
        prop: 'judgmentResult',
        width: 150,
        type: "dictionary_tag",
        key: "JUDGMENT_RESULTS",
        wrap: true,

      }, {
        label: 'tuihuoshuliang',
        prop: 'returnQuantity',
        width: 160
      }, {
        label: 'shengchanriqi',
        prop: 'productionDate',
        type: 'time',
        format: 'YYYY-MM-DD',
        width: 160
      }, {
        label: 'shixiaoriqi',
        prop: 'expirationDate',
        type: 'time',
        format: 'YYYY-MM-DD',
        width: 160
      }, {
        label: 'shouhuoriqi',
        prop: 'receiptDate',
        type: 'time',
        format: 'YYYY-MM-DD',
        width: 160
      }, {
        label: 'beizhu',
        prop: 'remark',
        width: 160
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 100,
        wrap: true,
        fixed: 'right'
      }],
    }
  },
  watch:{
    "yt.isShowEditDialog":{
      handler(n) {
        // if(this.yt.editObj.action=='chakan'&&n==false){
        //   console.log('dddddsss',n)
        //   this.yt.get(1);
        // }
        if (this.yt.editObj.action == "xinjiandaohuodan" && n == false) {
          this.addList = []
        }
      },
      immediate: false,
      deep: true
    },
    "yt.editObj.supplierId":{
      handler(n) {
       this.purchaseOrderDetailIds = []
       this.addList = []
       this.supplierId = this.yt.editObj.supplierId
      },
      immediate: false,
      deep: true
    },
  },
  created() {
    this.getProductionConfig();
    setTimeout(() => {
      //表格默认按照异常类型编码升序排序。
      // this.yt.conditions = {
      //   orderBy: 'code asc',
      // }
      this.yt.get(1);
      this.utils.event_hub.$on('PURCHASING_ASN_REFRESH', () => {
        this.yt.get();
      })
    }, 300)
  },
  methods: {
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumnsItem('sehao');
        }
      });
    },
    // 显示 新增/编辑-销售订单明细 指定列
    showColumnsItem(label) {
      for (let i = 0; i < this.columnsItem.length; i++) {
        const c = this.columnsItem[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    celarSupplierIds(){
      this.purchaseOrderDetailIds = []
    },
    getConfiguration(){
      let params = {
        type:0,
        categories:0
      }
      return this.http.get('/web/document/permission/configuration/item/list?' + this.qs.stringify(params)).then(res=>{
        this.smallNameList = res.data
      })
    },
    beforeAdd(params, url) {
      params.asnDetailList = this.addList
      return params
    },
    takeDelivery(){
      this.isShowEditDialog = true
    },
    getItemAddress(address){
      this.isShowButton = false;
      this.$nextTick(() => {
        this.isShowButton = true;
      });
      this.yt.editObj.address = address.address;
      this.supplierId=address.id;
    
    },
    getPurchaseOrder(index, item) {
      //遍历item
      for (let i = 0; i < item.length; i++) {
        const currentItem = item[i];
        this.addList.push({
          purchaserOrderNo: currentItem.purchaserOrderNo,
          purchaseOrderId: currentItem.purchaserOrderId,
          purchaseOrderDetailId: currentItem.id,
          no: currentItem.no ,
          codeName: currentItem.material==null?'':currentItem.material.code + '/' + currentItem.material.name,
          quantity: currentItem.quantity,
          deliveryQuantitySum: currentItem.deliveryQuantitySum,
          deliveryQuantityResidue: currentItem.deliveryQuantityResidue,
          unit: currentItem.unit,
          deliveryQuantity: '',
          receiveQuantity: '',
          colorNo: currentItem.colorNo,
          productionDate: '',
          expirationDate: '',
          receiptDate: '',
          remark: '',
        });
      }
      console.log('addList:',this.addList)
      // console.log("index:", index, "item:", item)
      // this.$set(this.addList[index], 'quantity', item.quantity || '')
      // this.$set(this.addList[index], 'unit', item.unit || '')
      // this.$set(this.addList[index], 'no', item.no || '')
      // this.$set(this.addList[index], 'codeName', item.material.code+'/'+item.material.name || '')
      // this.$set(this.addList[index], 'purchaseOrderId', item.purchaserOrderId || '')
      // this.$set(this.addList[index], 'deliveryQuantitySum', item.deliveryQuantitySum || '')
      // this.$set(this.addList[index], 'deliveryQuantityResidue', item.deliveryQuantityResidue || '')
    },
    beforeEdit(row) {
      this.editList = row.asnDetailList
      return row
    },
    addNew(index, item) {
      if (this.supplierId === ''||this.supplierId ==null) {
          this.utils.errorMessage(this.$t("qingxuanzhegongyingshang"));
          return;
        }
      const newItem = {
        purchaseOrderId: '',
        no: '',
        codeName: '',
        quantity: '',
        deliveryQuantitySum: '',
        deliveryQuantityResidue: '',
        unit: '',
        deliveryQuantity: '',
        receiveQuantity: '',
        colorNo: '',
        productionDate: '',
        expirationDate: '',
        receiptDate: '',
        remark: '',
      }
      this.addList.push(newItem)
    },
    removeAdd(index, item) {
      this.addList.splice(index, 1)
    },
    // 获取供应商编码、名称
    async getSupplierList() {
      return await this.http.get('/web/supplier/page?' + this.qs.stringify({
        pageNum: 1,
        pageSize: 999,
        // orderBy: 'sort',
      })).then(response => {
        this.supplierList = response.data.rows || []
        for (let i = 0; i < this.supplierList.length; i++) {
          const supplierCodeName = this.supplierList[i]['code'] + '/' + this.supplierList[i]['name']
          this.$set(this.supplierList[i], 'supplierCodeName', supplierCodeName)
        }
        console.log('this.supplierList', this.supplierList)
      })
    },
  }
}
</script>
